import getPitch from './pitch-detection';
import p5 from 'p5';
import 'p5/lib/addons/p5.sound';
import 'p5/lib/addons/p5.dom';

import {drawWaterColorBrush} from './watercolor';

export default function sketch(p) {
  let source, fft, lowPass;
  let amplitude;
  let brush = watercolorBrush;
  let noteName;
  let targetFrequency;
  let x, y;
  let targetX, targetY;
  const particles = [];

  function frequencyToColor(freq) {
    const COLORS = [
      '#FF0001',
      '#FF4401',
      '#D66F01',
      '#FFC503',
      '#E0EA03',
      '#76D102',
      '#01FFAB',
      '#00FFE7',
      '#00B2FF',
      '#3409FF',
      '#9E07FF',
      '#FF03FD',
    ];
    const NOTE_FREQUENCIES = [
      16.35,
      17.32,
      18.35,
      19.45,
      20.6,
      21.83,
      23.12,
      24.5,
      25.96,
      27.5,
      29.14,
      30.87,
    ];
    let i = 0;
    let j = 0;
    while (i < 200) {
      NOTE_FREQUENCIES.push(NOTE_FREQUENCIES[j] * 2);
      j++;
      i++;
    }
    const NOTES = [
      'C',
      'C#',
      'D',
      'D#',
      'E',
      'F',
      'F#',
      'G',
      'G#',
      'A',
      'A#',
      'B',
    ];

    const level = amplitude.getLevel();
    if (level < 0.001) {
      return 'black';
    }

    // const nfreq = normalizeToFit(NOTE_FREQUENCIES, freq);
    p.fill(0);
    // text ('Estimated Low Frequency: ' + nfreq.toFixed(2), 20, 20);
    const note = findClosest(NOTE_FREQUENCIES, freq);
    const index = NOTE_FREQUENCIES.indexOf(note);
    const nindex = index % COLORS.length;
    const color = COLORS[nindex];
    noteName = NOTES[nindex];
    targetFrequency = note;

    return color;
  }

  function findClosest(arr, value) {
    const distances = arr.map(v => Math.abs(v - value));
    const mindist = p.min(distances);
    return arr[distances.indexOf(mindist)];
  }

  function watercolorBrush({level, spectrumColor, x, y}) {
    drawWaterColorBrush(p, x, y, level * 800, spectrumColor);
  }

  function colorAlpha(aColor, alpha) {
    var c = p.color(aColor);
    return p.color(
      'rgba(' + [p.red(c), p.green(c), p.blue(c), alpha].join(',') + ')',
    );
  }

  p.myCustomRedrawAccordingToNewPropsHandler = function myCustomRedrawAccordingToNewPropsHandler(
    props,
  ) {};

  p.setup = function setup() {
    console.log('creating canvas');
    p.createCanvas(p.windowWidth, p.windowHeight);
    p.noFill();

    // uncomment me to use mic
    source = new p5.AudioIn();
    source.start();

    // source.play(); // comment me to use mic

    amplitude = new p5.Amplitude();
    amplitude.setInput(source);

    lowPass = new p5.LowPass();
    lowPass.disconnect();
    source.connect(lowPass);

    fft = new p5.FFT();
    fft.setInput(lowPass);

    p.background(255);

    // const squareBrushButton = p5.createButton('Square Brush');
    // squareBrushButton.position(p.width - 100, p.height - 20);
    // squareBrushButton.mousePressed(() => (brush = squareBrush));
    // const circleBrushButton = p5.createButton('Circle Brush');
    // circleBrushButton.position(p.width - 100, p.height - 40);
    // circleBrushButton.mousePressed(() => (brush = circleBrush));

    x = p.width / 2;
    y = p.height / 2;
    targetX = x;
    targetY = y;

    for (let j = 0; j < 2; j++) {
      particles.push(new Particle());
    }
    lastSpectrumColor = p.color(0);
  };

  let storedEllipses = [];
  let lastSpectrumColor;
  p.draw = function draw() {
    const timeDomain = fft.waveform(1024, 'float32');
    const freq = getPitch(p, timeDomain);
    const spectrumColor = frequencyToColor(freq);
    const level = amplitude.getLevel();

    // lastSpectrumColor = p.lerpColor(
    //   lastSpectrumColor,
    //   p.color(colorAlpha(spectrumColor, 0.005)),
    //   0.03,
    // );
    p.background(colorAlpha(0, 0.05));

    p.noFill();

    if (p.frameCount % 100 === 0) {
      targetX = p.random(p.width);
      targetY = p.random(p.height);
    }

    p.onChange &&
      p.onChange({
        frequency: freq,
        spectrumColor,
        targetFrequency,
        noteName,
        level,
      });

    p.noStroke();
    // p.stroke(255)

    x = p.lerp(x, targetX, 0.01);
    y = p.lerp(y, targetY, 0.01);

    brush({
      level: level * 2,
      spectrumColor,
      x: p.width / 2,
      y: p.height / 2,
    });

    // particles.forEach(particle => {
    //   particle.update();
    //   particle.draw(level, spectrumColor);
    // });
  };

  class Particle {
    constructor() {
      this.x = p.random(p.width);
      this.y = p.random(p.height);
      this.targetX = x;
      this.targetY = y;
      this.scaleFactor = p.randomGaussian(1, 1);
    }

    update() {
      if (p.frameCount % 100 === 0) {
        this.targetX = p.random(p.width);
        this.targetY = p.random(p.height);
      }
      this.x = p.lerp(this.x, this.targetX, 0.01);
      this.y = p.lerp(this.y, this.targetY, 0.01);
    }

    draw(level, spectrumColor) {
      brush({
        level: level * this.scaleFactor,
        spectrumColor,
        x: this.x,
        y: this.y,
      });
    }
  }

  p.touchStarted = function touchStarted() {
    p.getAudioContext().resume();
  };
}



// WEBPACK FOOTER //
// ./src/sketches/center-water-color.js